module.exports = __webpack_public_path__ + "static/media/nissan_boy_expired.4b16029f.png";